enum FilterType {
  composable = 'composable',
  nfts = 'nfts',
}

export default FilterType;
